"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBFilter", {
  enumerable: true,
  get: function get() {
    return _SVBFilter.default;
  }
});
var _SVBFilter = _interopRequireDefault(require("./src/SVBFilter"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }